var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "user-form" }, [
    _c(
      "div",
      { staticClass: "animated fadeIn" },
      [
        _c(
          "b-row",
          [
            _c(
              "b-col",
              { attrs: { cols: "12" } },
              [
                _c(
                  "b-card",
                  { attrs: { "header-tag": "header", "footer-tag": "footer" } },
                  [
                    _c("div", { attrs: { slot: "header" }, slot: "header" }, [
                      _c("i", { attrs: { className: "fa fa-align-justify" } }),
                      _c("strong", [_vm._v(_vm._s(_vm.$t("edit")))]),
                      _vm._v(" "),
                      _c("div", { staticClass: "card-actions" })
                    ]),
                    _vm._v(" "),
                    _vm.item.uuid != null
                      ? _c(
                          "b-form",
                          { staticClass: "row" },
                          [
                            _c(
                              "b-col",
                              { attrs: { cols: "3" } },
                              [
                                _c(
                                  "b-form-group",
                                  { attrs: { label: _vm.$t("avatar") } },
                                  [
                                    _c("b-form-file", {
                                      ref: "avatar",
                                      attrs: {
                                        id: "avatarData",
                                        accept: "image/*"
                                      },
                                      on: { change: _vm.previewImage }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "image-desktop-preview" },
                                  [
                                    _c("img", {
                                      staticClass: "preview-image",
                                      attrs: {
                                        src:
                                          _vm.avatarData != ""
                                            ? _vm.avatarData
                                            : _vm.item.avatar
                                      }
                                    })
                                  ]
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-col",
                              { attrs: { cols: "9" } },
                              [
                                _c(
                                  "b-form-group",
                                  {
                                    attrs: {
                                      label: _vm.$t("name"),
                                      "label-cols": 3,
                                      horizontal: true
                                    }
                                  },
                                  [
                                    _c("b-form-input", {
                                      staticClass: "form-control",
                                      attrs: {
                                        "aria-describedby": "nameFeedback"
                                      },
                                      model: {
                                        value: _vm.item.name,
                                        callback: function($$v) {
                                          _vm.$set(_vm.item, "name", $$v)
                                        },
                                        expression: "item.name"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-form-group",
                                  {
                                    attrs: {
                                      label: _vm.$t("username"),
                                      "label-cols": 3,
                                      horizontal: true
                                    }
                                  },
                                  [
                                    _c("b-form-input", {
                                      staticClass: "form-control",
                                      attrs: {
                                        "aria-describedby": "usernameFeedback"
                                      },
                                      model: {
                                        value: _vm.item.username,
                                        callback: function($$v) {
                                          _vm.$set(_vm.item, "username", $$v)
                                        },
                                        expression: "item.username"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-form-group",
                                  {
                                    attrs: {
                                      label: _vm.$t("email"),
                                      "label-cols": 3,
                                      horizontal: true
                                    }
                                  },
                                  [
                                    _c("b-form-input", {
                                      staticClass: "form-control",
                                      attrs: {
                                        "aria-describedby": "emailFeedback"
                                      },
                                      model: {
                                        value: _vm.item.email,
                                        callback: function($$v) {
                                          _vm.$set(_vm.item, "email", $$v)
                                        },
                                        expression: "item.email"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-form-group",
                                  {
                                    attrs: {
                                      label: _vm.$t("password"),
                                      "label-cols": 3,
                                      horizontal: true
                                    }
                                  },
                                  [
                                    _c("b-form-input", {
                                      staticClass: "form-control",
                                      attrs: {
                                        type: "password",
                                        "aria-describedby": "passwordFeedback"
                                      },
                                      model: {
                                        value: _vm.item.password,
                                        callback: function($$v) {
                                          _vm.$set(_vm.item, "password", $$v)
                                        },
                                        expression: "item.password"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-form-group",
                                  {
                                    attrs: {
                                      label: _vm.$t("confirm_password"),
                                      "label-cols": 3,
                                      horizontal: true
                                    }
                                  },
                                  [
                                    _c("b-form-input", {
                                      staticClass: "form-control",
                                      attrs: {
                                        type: "password",
                                        "aria-describedby":
                                          "passwordConfirmationFeedback"
                                      },
                                      model: {
                                        value: _vm.item.password_confirmation,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.item,
                                            "password_confirmation",
                                            $$v
                                          )
                                        },
                                        expression: "item.password_confirmation"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-form-group",
                                  {
                                    attrs: {
                                      label: _vm.$t("store"),
                                      "label-cols": 3,
                                      horizontal: true
                                    }
                                  },
                                  [
                                    _c("b-form-select", {
                                      attrs: {
                                        options:
                                          _vm.outlets[_vm.$session.get("lang")]
                                      },
                                      model: {
                                        value: _vm.item.store_code,
                                        callback: function($$v) {
                                          _vm.$set(_vm.item, "store_code", $$v)
                                        },
                                        expression: "item.store_code"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-form-group",
                                  {
                                    attrs: {
                                      label: _vm.$t("active"),
                                      "label-cols": "3",
                                      horizontal: true
                                    }
                                  },
                                  [
                                    _c(
                                      "c-switch",
                                      _vm._b(
                                        {
                                          attrs: {
                                            type: "icon",
                                            variant: "primary",
                                            checked: _vm.item.active,
                                            value: 1,
                                            uncheckedValue: 0
                                          },
                                          model: {
                                            value: _vm.item.active,
                                            callback: function($$v) {
                                              _vm.$set(_vm.item, "active", $$v)
                                            },
                                            expression: "item.active"
                                          }
                                        },
                                        "c-switch",
                                        { on: "\uf00c", off: "\uf00d" },
                                        false
                                      )
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("b-col", { attrs: { cols: "12" } }, [_c("hr")]),
                            _vm._v(" "),
                            _vm._l(_vm.roles, function(role) {
                              return _c(
                                "b-col",
                                { key: role.code, attrs: { cols: "3" } },
                                [
                                  _c(
                                    "label",
                                    {
                                      staticClass:
                                        "switch switch-icon switch-primary"
                                    },
                                    [
                                      _c("input", {
                                        staticClass: "switch-input",
                                        attrs: {
                                          type: "checkbox",
                                          name: "roles[]"
                                        },
                                        domProps: {
                                          value: role.id,
                                          checked:
                                            _vm._.indexOf(
                                              _vm.item.roleIds,
                                              role.id
                                            ) >= 0
                                              ? true
                                              : false
                                        },
                                        on: { change: _vm.updatePermission }
                                      }),
                                      _vm._v(" "),
                                      _c("span", {
                                        staticClass: "switch-label",
                                        attrs: {
                                          "data-on": "",
                                          "data-off": ""
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("span", {
                                        staticClass: "switch-handle"
                                      })
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "legend",
                                    { staticClass: "col-form-label" },
                                    [
                                      _c(
                                        "small",
                                        { staticClass: "text-muted" },
                                        [_vm._v(_vm._s(role.name))]
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "role-permissions" },
                                    _vm._l(role.permissions, function(
                                      permission
                                    ) {
                                      return _c(
                                        "div",
                                        {
                                          key: permission.id,
                                          staticClass: "role-permission"
                                        },
                                        [
                                          _c("input", {
                                            attrs: { type: "hidden" },
                                            domProps: { value: permission.id }
                                          })
                                        ]
                                      )
                                    })
                                  )
                                ]
                              )
                            }),
                            _vm._v(" "),
                            _c("b-col", { attrs: { cols: "12" } }, [_c("hr")]),
                            _vm._v(" "),
                            _vm._l(_vm.permissions, function(permission) {
                              return _c(
                                "div",
                                { key: permission.code, staticClass: "col-3" },
                                [
                                  _c(
                                    "label",
                                    {
                                      class:
                                        "switch switch-icon switch-" +
                                        (_vm.checkPermissionInRole(
                                          permission.id
                                        )
                                          ? "secondary"
                                          : "primary")
                                    },
                                    [
                                      _c("input", {
                                        staticClass: "switch-input",
                                        attrs: {
                                          type: "checkbox",
                                          name: "roles[]"
                                        },
                                        domProps: {
                                          value: permission.id,
                                          checked: _vm.checkPermission(
                                            permission.id
                                          )
                                        },
                                        on: { change: _vm.updateRole }
                                      }),
                                      _vm._v(" "),
                                      _c("span", {
                                        staticClass: "switch-label",
                                        attrs: {
                                          "data-on": "",
                                          "data-off": ""
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("span", {
                                        staticClass: "switch-handle"
                                      })
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "legend",
                                    { staticClass: "col-form-label" },
                                    [
                                      _vm._v(
                                        _vm._s(permission.name) +
                                          "\n                "
                                      ),
                                      _c(
                                        "small",
                                        { staticClass: "text-muted" },
                                        [_vm._v(_vm._s(permission.description))]
                                      )
                                    ]
                                  )
                                ]
                              )
                            })
                          ],
                          2
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "text-center",
                        attrs: { slot: "footer" },
                        slot: "footer"
                      },
                      [
                        _c(
                          "router-link",
                          { attrs: { to: { name: _vm.model + "_list" } } },
                          [
                            _c("b-button", { attrs: { variant: "default" } }, [
                              _c("i", { staticClass: "fa fa-arrow-left" }),
                              _vm._v(" " + _vm._s(_vm.$t("back")))
                            ])
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _vm.uuid != null &&
                        _vm.$auth.check(_vm.model + ".update")
                          ? _c(
                              "b-button",
                              {
                                attrs: { variant: "success" },
                                on: { click: _vm.updateItem }
                              },
                              [
                                _c("i", { staticClass: "fa fa-save" }),
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.$t("update")) +
                                    "\n            "
                                )
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.uuid == null &&
                        _vm.$auth.check(_vm.model + ".create")
                          ? _c(
                              "b-button",
                              {
                                attrs: { variant: "success" },
                                on: { click: _vm.createItem }
                              },
                              [
                                _c("i", { staticClass: "fa fa-save" }),
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.$t("save")) +
                                    "\n            "
                                )
                              ]
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-68641abe", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-68641abe","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/admin/user/Form.vue
// module id = 1168
// module chunks = 0